import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner, VStack } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { PodcastListNavCard } from '@src/components/sco/Education/PodcastListNav/PodcastListNavCard';
import { gql, gqlArgs, gqlVars } from '@src/lib/gql';
import React from 'react';
type PodcastListNavProps = {
  keywords?: string;
  termSlugs?: string[];
};
export const PodcastListNav = props => {
  const $ = _c(17);
  useEducationContext();
  let t0;
  if ($[0] !== props) {
    t0 = PodcastListNav.queries.podcastEpisodes(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.keywords || $[3] !== props.termSlugs) {
    t1 = {
      variables: {
        termSlugs: props.termSlugs,
        keywords: props.keywords
      }
    };
    $[2] = props.keywords;
    $[3] = props.termSlugs;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[5] !== query.loading) {
    t2 = query.loading && <Center padding="1em"><Spinner /></Center>;
    $[5] = query.loading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== query.error) {
    t3 = query.error && <p>{"Error: "}{query.error.message}</p>;
    $[7] = query.error;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== query.data?.podcastEpisodes) {
    t4 = query.data?.podcastEpisodes.map(_temp);
    $[9] = query.data?.podcastEpisodes;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <VStack align="flex-start" gap={0} height="full" overflowY="scroll" width="full">{t4}</VStack>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t5) {
    t6 = <VStack align="flex-start" gap={2} height="full" minHeight="50vh" overflow="hidden" paddingY={3} width="full">{t2}{t3}{t5}</VStack>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
PodcastListNav.fragments = {
  PodcastEpisode: () => gql`
    fragment _ on PodcastEpisode {
      id
      slug
      title
      number
      posterImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 300 } } })
      }
    }
  `
};
PodcastListNav.queries = {
  podcastEpisodes: props => {
    const vars = gqlVars({
      '$keywords: String': props.keywords,
      '$termSlugs: [String]': props.termSlugs?.length > 0
    });
    const where = gqlArgs({
      'where: ': {
        '_search: $keywords': props.keywords,
        'terms_some: { slug_in: $termSlugs }': props.termSlugs?.length > 0
      }
    });
    return gql`
      query ${vars} {
        podcastEpisodes (
          orderBy: number_DESC
          ${where}
        ) {
          ${PodcastListNav.fragments.PodcastEpisode()}
        }
      }
    `;
  }
};
function _temp(podcast) {
  return <PodcastListNavCard key={podcast.id} id={podcast.id} image={podcast.posterImage?.url} podcast={podcast} slug={podcast.slug} />;
}